import React from 'react';
import Layout from '../components/layout/Layout';
import './About.css'
import one from '../assets/img1.jpeg'	
import two from '../assets/img2.jpeg'	
import three from '../assets/img3.jpeg'

function About(props) {
    return (
        <Layout>
             <div className="container mt-5">
        <h2 className="text-center mb-4">We are Glad</h2>
        <h5 className="text-center mb-4 text-secondary">Thank you for choosing sunshine residence as your home.</h5>
        <p className='text-secondary'>
            contact us: +254 748439084 | email: sunshinehostbondo@gmail.com
        </p>
        <div id="galleryCarousel" className="carousel slide" data-bs-ride="carousel">
            <div className="carousel-inner">
                <div className="carousel-item active">
                    <img src={two} className="d-block w-100" alt=" 1"/>
                </div>
                <div className="carousel-item">
                    <img src={one} className="d-block w-100" alt=" 2"/>
                </div>
                <div className="carousel-item rounded">
                    <img src={three} className="d-block w-100" alt="3"/>
                </div>
            </div>
            <button className="carousel-control-prev" type="button" data-bs-target="#galleryCarousel" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#galleryCarousel" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
            </button>
        </div>

        <div className="row mt-4">
            <div className="col-md-4 mb-3 gallery-item">
                <img src={three} className="w-100 shadow-sm" alt=""/>
            </div>
            <div className="col-md-4 mb-3 gallery-item">
                <img src={two} className="w-100 shadow-sm" alt=""/>
            </div>
            <div className="col-md-4 mb-3 gallery-item">
                <img src={one} className="w-100 shadow-sm" alt=""/>
            </div>
        </div>
    </div>
        </Layout>
    );
}

export default About;